export { default, default as InitialsAvatar } from './InitialsAvatar'
export { default as initialsAvatarTheme } from './themes/InitialsAvatar.theme'
export * as InitialsAvatarStyles from './styles/InitialsAvatar.style'

export type { InitialsAvatarProps } from './InitialsAvatar.types'
export type { AppearanceKeys, InitialsAvatarTheme } from './themes/InitialsAvatar.theme.types'
export type { StyledInitialsAvatarProps } from './styles/InitialsAvatar.style.types'
